import { render, staticRenderFns } from "./TraspasosModal.vue?vue&type=template&id=5e90a26f&"
import script from "./TraspasosModal.vue?vue&type=script&lang=js&"
export * from "./TraspasosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports